import React from 'react';
import { Button } from 'reactstrap';
import { withFormik } from 'formik';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { TextInput } from './FormElements';

const loginUser = withFormik({
  validationSchema: Yup.object().shape({
    username: Yup.string().required('Username is required'),
    password: Yup.string().required('Password is required'),
  }),
  handleSubmit: async (payload, { props, setSubmitting, setErrors }) => {
    try {
      const errors = await props.handleSubmit(payload);
      setSubmitting(false);
      setErrors(errors);
    } catch (e) {
      throw e;
    }
  },
  displayName: 'LoginForm',
});

const loginForm = (props) => {
  const {
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = props;

  return (
    <form onSubmit={handleSubmit} className='login-form'>
      <TextInput
        id='username'
        type='text'
        label={props.userNameLabel}
        labelClassName='sr-only'
        placeholder={props.userNameLabel}
        error={errors.username}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <TextInput
        id='password'
        type='password'
        label={props.passwordLabel}
        labelClassName='sr-only'
        placeholder={props.passwordLabel}
        error={touched.password && errors.password}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Button
        type='submit'
        color='primary'
        disabled={!props.isValid || isSubmitting}
      >
        LOGIN
      </Button>
      <Link to='/forgot'>Forgot your password?</Link>

      {isSubmitting && <div className='loader'>Loading...</div>}
    </form>
  );
};

export const LoginForm = loginUser(loginForm);
